export const headerImage = {
  medium: {
    width: 708,
    url: 'https://assets.riparide.com/landing_pages/how_it_works/header/medium-2022-04-21.jpg',
  },
  large: {
    width: 1062,
    url: 'https://assets.riparide.com/landing_pages/how_it_works/header/large-2022-04-21.jpg',
  },
  hero: {
    width: 1416,
    url: 'https://assets.riparide.com/landing_pages/how_it_works/header/hero-2022-04-21.jpg',
  },
}

export const giftingImages = {
  desktop: {
    medium: {
      width: 756,
      url: 'https://assets.riparide.com/landing_pages/how_it_works/gifting/medium-2022-04-21.png',
    },
    large: {
      width: 1133,
      url: 'https://assets.riparide.com/landing_pages/how_it_works/gifting/large-2022-04-21.png',
    },
    hero: {
      width: 1511,
      url: 'https://assets.riparide.com/landing_pages/how_it_works/gifting/hero-2022-04-21.png',
    },
  },
  mobile: {
    medium: {
      width: 756,
      url: 'https://assets.riparide.com/landing_pages/how_it_works/gifting/medium_mobile-2022-04-22.png',
    },
    large: {
      width: 1133,
      url: 'https://assets.riparide.com/landing_pages/how_it_works/gifting/large_mobile-2022-04-22.png',
    },
    hero: {
      width: 1511,
      url: 'https://assets.riparide.com/landing_pages/how_it_works/gifting/hero_mobile-2022-04-22.png',
    },
  },
}

export const masonryImages = [
  {
    medium:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/portrait/1/large-2022-04-21.jpg',
    large:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/portrait/1/large-2022-04-21.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/landscape/1/medium-2022-04-21.jpg',
    large:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/landscape/1/medium-2022-04-21.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/landscape/2/medium-2022-04-21.jpg',
    large:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/landscape/2/medium-2022-04-21.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/portrait/2/medium-2022-04-21.jpg',
    large:
      'https://assets.riparide.com/landing_pages/how_it_works/storytelling_masonry/portrait/2/medium-2022-04-21.jpg',
  },
]
